module.exports = __webpack_public_path__ + "assets/img/22-m.89d0b7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/22-m.jpg
// module id = kew0
// module chunks = 0